import { render, staticRenderFns } from "./CalcBlockControls.vue?vue&type=template&id=4df8ac92&scoped=true&"
import script from "./CalcBlockControls.vue?vue&type=script&lang=js&"
export * from "./CalcBlockControls.vue?vue&type=script&lang=js&"
import style0 from "./CalcBlockControls.vue?vue&type=style&index=0&id=4df8ac92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df8ac92",
  null
  
)

export default component.exports